import React, { useState, useEffect } from "react";

type Props = {
  children: React.ReactNode;
  waitBeforeShowMs?: number;
};

const Delayed = ({
  children,
  waitBeforeShowMs: waitBeforeShow = 500,
}: Props) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
    return () => clearTimeout(timer);
  }, [waitBeforeShow]);

  return isShown ? <>{children}</> : <></>;
};

export default Delayed;
